/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

//==============================================================
// START Enums and Input Objects
//==============================================================

export enum BasketType {
    COLLECT = 'COLLECT',
    DELIVERY = 'DELIVERY',
}

/**
 * The list of available currency codes.
 */
export enum CurrencyEnum {
    AED = 'AED',
    AFN = 'AFN',
    ALL = 'ALL',
    AMD = 'AMD',
    ANG = 'ANG',
    AOA = 'AOA',
    ARS = 'ARS',
    AUD = 'AUD',
    AWG = 'AWG',
    AZM = 'AZM',
    AZN = 'AZN',
    BAM = 'BAM',
    BBD = 'BBD',
    BDT = 'BDT',
    BGN = 'BGN',
    BHD = 'BHD',
    BIF = 'BIF',
    BMD = 'BMD',
    BND = 'BND',
    BOB = 'BOB',
    BRL = 'BRL',
    BSD = 'BSD',
    BTN = 'BTN',
    BUK = 'BUK',
    BWP = 'BWP',
    BYN = 'BYN',
    BZD = 'BZD',
    CAD = 'CAD',
    CDF = 'CDF',
    CHE = 'CHE',
    CHF = 'CHF',
    CHW = 'CHW',
    CLP = 'CLP',
    CNY = 'CNY',
    COP = 'COP',
    CRC = 'CRC',
    CUP = 'CUP',
    CVE = 'CVE',
    CZK = 'CZK',
    DJF = 'DJF',
    DKK = 'DKK',
    DOP = 'DOP',
    DZD = 'DZD',
    EEK = 'EEK',
    EGP = 'EGP',
    ERN = 'ERN',
    ETB = 'ETB',
    EUR = 'EUR',
    FJD = 'FJD',
    FKP = 'FKP',
    GBP = 'GBP',
    GEK = 'GEK',
    GEL = 'GEL',
    GHS = 'GHS',
    GIP = 'GIP',
    GMD = 'GMD',
    GNF = 'GNF',
    GQE = 'GQE',
    GTQ = 'GTQ',
    GYD = 'GYD',
    HKD = 'HKD',
    HNL = 'HNL',
    HRK = 'HRK',
    HTG = 'HTG',
    HUF = 'HUF',
    IDR = 'IDR',
    ILS = 'ILS',
    INR = 'INR',
    IQD = 'IQD',
    IRR = 'IRR',
    ISK = 'ISK',
    JMD = 'JMD',
    JOD = 'JOD',
    JPY = 'JPY',
    KES = 'KES',
    KGS = 'KGS',
    KHR = 'KHR',
    KMF = 'KMF',
    KPW = 'KPW',
    KRW = 'KRW',
    KWD = 'KWD',
    KYD = 'KYD',
    KZT = 'KZT',
    LAK = 'LAK',
    LBP = 'LBP',
    LKR = 'LKR',
    LRD = 'LRD',
    LSL = 'LSL',
    LSM = 'LSM',
    LTL = 'LTL',
    LVL = 'LVL',
    LYD = 'LYD',
    MAD = 'MAD',
    MDL = 'MDL',
    MGA = 'MGA',
    MKD = 'MKD',
    MMK = 'MMK',
    MNT = 'MNT',
    MOP = 'MOP',
    MRO = 'MRO',
    MUR = 'MUR',
    MVR = 'MVR',
    MWK = 'MWK',
    MXN = 'MXN',
    MYR = 'MYR',
    MZN = 'MZN',
    NAD = 'NAD',
    NGN = 'NGN',
    NIC = 'NIC',
    NOK = 'NOK',
    NPR = 'NPR',
    NZD = 'NZD',
    OMR = 'OMR',
    PAB = 'PAB',
    PEN = 'PEN',
    PGK = 'PGK',
    PHP = 'PHP',
    PKR = 'PKR',
    PLN = 'PLN',
    PYG = 'PYG',
    QAR = 'QAR',
    RHD = 'RHD',
    ROL = 'ROL',
    RON = 'RON',
    RSD = 'RSD',
    RUB = 'RUB',
    RWF = 'RWF',
    SAR = 'SAR',
    SBD = 'SBD',
    SCR = 'SCR',
    SDG = 'SDG',
    SEK = 'SEK',
    SGD = 'SGD',
    SHP = 'SHP',
    SKK = 'SKK',
    SLL = 'SLL',
    SOS = 'SOS',
    SRD = 'SRD',
    STD = 'STD',
    SVC = 'SVC',
    SYP = 'SYP',
    SZL = 'SZL',
    THB = 'THB',
    TJS = 'TJS',
    TMM = 'TMM',
    TND = 'TND',
    TOP = 'TOP',
    TRL = 'TRL',
    TRY = 'TRY',
    TTD = 'TTD',
    TWD = 'TWD',
    TZS = 'TZS',
    UAH = 'UAH',
    UGX = 'UGX',
    USD = 'USD',
    UYU = 'UYU',
    UZS = 'UZS',
    VEB = 'VEB',
    VEF = 'VEF',
    VND = 'VND',
    VUV = 'VUV',
    WST = 'WST',
    XCD = 'XCD',
    XOF = 'XOF',
    XPF = 'XPF',
    YER = 'YER',
    YTL = 'YTL',
    ZAR = 'ZAR',
    ZMK = 'ZMK',
    ZWD = 'ZWD',
}

/**
 * States whether a product stock status is in stock or out of stock.
 */
export enum ProductStockStatus {
    IN_STOCK = 'IN_STOCK',
    OUT_OF_STOCK = 'OUT_OF_STOCK',
}

/**
 * Indicates whether to return results in ascending or descending order.
 */
export enum SortEnum {
    ASC = 'ASC',
    DESC = 'DESC',
}

/**
 * This enumeration defines the entity type.
 */
export enum UrlRewriteEntityTypeEnum {
    BUNDLE_PRODUCT = 'BUNDLE_PRODUCT',
    CATEGORY = 'CATEGORY',
    CATEGORY_PRODUCT_LIST = 'CATEGORY_PRODUCT_LIST',
    CMS_PAGE = 'CMS_PAGE',
    COMING_SOON_BUNDLE_PRODUCT = 'COMING_SOON_BUNDLE_PRODUCT',
    COMING_SOON_CONFIGURABLE_PRODUCT = 'COMING_SOON_CONFIGURABLE_PRODUCT',
    COMING_SOON_GROUPED_PRODUCT = 'COMING_SOON_GROUPED_PRODUCT',
    COMING_SOON_SIMPLE_PRODUCT = 'COMING_SOON_SIMPLE_PRODUCT',
    COMING_SOON_VIRTUAL_PRODUCT = 'COMING_SOON_VIRTUAL_PRODUCT',
    CONFIGURABLE_PRODUCT = 'CONFIGURABLE_PRODUCT',
    GROUPED_PRODUCT = 'GROUPED_PRODUCT',
    PRODUCT = 'PRODUCT',
    SIMPLE_PRODUCT = 'SIMPLE_PRODUCT',
    VIRTUAL_PRODUCT = 'VIRTUAL_PRODUCT',
}

/**
 * Defines a filter that matches the input exactly.
 */
export interface FilterEqualTypeInput {
    eq?: string | null;
    in?: (string | null)[] | null;
}

/**
 * Defines a filter that performs a fuzzy search.
 */
export interface FilterMatchTypeInput {
    match?: string | null;
}

/**
 * Defines a filter that matches a range of values, such as prices or dates.
 */
export interface FilterRangeTypeInput {
    from?: string | null;
    to?: string | null;
}

/**
 * Defines the filters to be used in the search. A filter contains at least one attribute, a comparison operator, and the value that is being searched for.
 */
export interface ProductAttributeFilterInput {
    Decoration_Type?: FilterEqualTypeInput | null;
    Waist_Sizee?: FilterEqualTypeInput | null;
    Workwear_Colour?: FilterEqualTypeInput | null;
    Workwear_Typee?: FilterEqualTypeInput | null;
    accessories?: FilterEqualTypeInput | null;
    accessory_type?: FilterEqualTypeInput | null;
    adhesive_type?: FilterEqualTypeInput | null;
    baking_type?: FilterEqualTypeInput | null;
    bar_pressure?: FilterEqualTypeInput | null;
    barbecue_accessories?: FilterEqualTypeInput | null;
    barbecue_type?: FilterEqualTypeInput | null;
    basket_material?: FilterEqualTypeInput | null;
    basket_size?: FilterEqualTypeInput | null;
    bath_mat_design?: FilterEqualTypeInput | null;
    bathroom_accessories_type?: FilterEqualTypeInput | null;
    bathroom_fittings_type?: FilterEqualTypeInput | null;
    bathroom_range?: FilterEqualTypeInput | null;
    bathroom_sets_fittings?: FilterEqualTypeInput | null;
    batteries?: FilterEqualTypeInput | null;
    batteries_type?: FilterEqualTypeInput | null;
    bbq_fuel_type?: FilterEqualTypeInput | null;
    bedroom_furniture_type?: FilterEqualTypeInput | null;
    bench_material?: FilterEqualTypeInput | null;
    bike_accessory?: FilterEqualTypeInput | null;
    bin_type?: FilterEqualTypeInput | null;
    bird_food_type?: FilterEqualTypeInput | null;
    blind_size?: FilterEqualTypeInput | null;
    boots_wellies_size?: FilterEqualTypeInput | null;
    brand?: FilterEqualTypeInput | null;
    bristle_material?: FilterEqualTypeInput | null;
    brush_type?: FilterEqualTypeInput | null;
    brushes_mops_and_buckets?: FilterEqualTypeInput | null;
    candle_holders_and_lanterns?: FilterEqualTypeInput | null;
    candle_shape?: FilterEqualTypeInput | null;
    candle_type?: FilterEqualTypeInput | null;
    car_care_type?: FilterEqualTypeInput | null;
    category_id?: FilterEqualTypeInput | null;
    category_tree?: FilterMatchTypeInput | null;
    category_uid?: FilterEqualTypeInput | null;
    charcoal_bbq_size?: FilterEqualTypeInput | null;
    christmas_cracker_type?: FilterEqualTypeInput | null;
    christmas_decorations?: FilterEqualTypeInput | null;
    christmas_textiles?: FilterEqualTypeInput | null;
    christmas_tree_size?: FilterEqualTypeInput | null;
    christmas_tree_trims_type?: FilterEqualTypeInput | null;
    christmas_tree_type?: FilterEqualTypeInput | null;
    cleaning_product?: FilterEqualTypeInput | null;
    cleaning_type?: FilterEqualTypeInput | null;
    cloth_and_glove_type?: FilterEqualTypeInput | null;
    cloths_and_gloves?: FilterEqualTypeInput | null;
    collar_size?: FilterEqualTypeInput | null;
    color?: FilterEqualTypeInput | null;
    colour?: FilterEqualTypeInput | null;
    colour_group?: FilterEqualTypeInput | null;
    colour_options?: FilterEqualTypeInput | null;
    compost_and_bark_type?: FilterEqualTypeInput | null;
    contents_size?: FilterEqualTypeInput | null;
    cooking_type?: FilterEqualTypeInput | null;
    corded_or_cordless_saw?: FilterEqualTypeInput | null;
    cordless_corded?: FilterEqualTypeInput | null;
    cover_shape?: FilterEqualTypeInput | null;
    cover_size?: FilterEqualTypeInput | null;
    coverage_area?: FilterEqualTypeInput | null;
    curtain_accessories?: FilterEqualTypeInput | null;
    curtain_pole_fixed_length?: FilterEqualTypeInput | null;
    curtain_pole_thickness?: FilterEqualTypeInput | null;
    cushions_and_throws?: FilterEqualTypeInput | null;
    cuting_blades_type?: FilterEqualTypeInput | null;
    cutting_pruning_type?: FilterEqualTypeInput | null;
    cylinder_lock_length?: FilterEqualTypeInput | null;
    cylinder_lock_type?: FilterEqualTypeInput | null;
    damp_stain_block_type?: FilterEqualTypeInput | null;
    deck_care_type?: FilterEqualTypeInput | null;
    decking_paving_fencing_type?: FilterEqualTypeInput | null;
    decorating_accessories?: FilterEqualTypeInput | null;
    decoration_colour?: FilterEqualTypeInput | null;
    decorative_timber_type?: FilterEqualTypeInput | null;
    dehumidifiers_tpye?: FilterEqualTypeInput | null;
    description?: FilterMatchTypeInput | null;
    design_type?: FilterEqualTypeInput | null;
    dining_room_furniture?: FilterEqualTypeInput | null;
    door_accessories?: FilterEqualTypeInput | null;
    door_bell_connection_type?: FilterEqualTypeInput | null;
    door_bells_and_chimes_type?: FilterEqualTypeInput | null;
    door_furniture?: FilterEqualTypeInput | null;
    door_locks_and_security_finish?: FilterEqualTypeInput | null;
    door_locks_and_security_type?: FilterEqualTypeInput | null;
    door_locks_security_lock_type?: FilterEqualTypeInput | null;
    doors_type?: FilterEqualTypeInput | null;
    drill_corded_or_cordless?: FilterEqualTypeInput | null;
    drill_type?: FilterEqualTypeInput | null;
    dust_sheet_material?: FilterEqualTypeInput | null;
    electrical_accessories_type?: FilterEqualTypeInput | null;
    engine_size?: FilterEqualTypeInput | null;
    engine_type?: FilterEqualTypeInput | null;
    essentials_type?: FilterEqualTypeInput | null;
    extension_leads?: FilterEqualTypeInput | null;
    fencecare_type?: FilterEqualTypeInput | null;
    fencing_type?: FilterEqualTypeInput | null;
    fire_pit_chiminea_material?: FilterEqualTypeInput | null;
    fixing_position?: FilterEqualTypeInput | null;
    fixings_type?: FilterEqualTypeInput | null;
    floor_type?: FilterEqualTypeInput | null;
    flooring_accessories_type?: FilterEqualTypeInput | null;
    floristry_type?: FilterEqualTypeInput | null;
    flow_rate_litre_hour?: FilterEqualTypeInput | null;
    food_size?: FilterEqualTypeInput | null;
    food_type?: FilterEqualTypeInput | null;
    footwear_size?: FilterEqualTypeInput | null;
    footwear_type?: FilterEqualTypeInput | null;
    frame?: FilterEqualTypeInput | null;
    fuel_type?: FilterEqualTypeInput | null;
    furniture_feature?: FilterEqualTypeInput | null;
    garden_accessories?: FilterEqualTypeInput | null;
    garden_accessory_type?: FilterEqualTypeInput | null;
    garden_chair_type?: FilterEqualTypeInput | null;
    garden_cushion_type?: FilterEqualTypeInput | null;
    garden_decor_type?: FilterEqualTypeInput | null;
    garden_furniture_accessories?: FilterEqualTypeInput | null;
    garden_furniture_care_type?: FilterEqualTypeInput | null;
    garden_furniture_type?: FilterEqualTypeInput | null;
    garden_set_frame_material?: FilterEqualTypeInput | null;
    garden_table_top_material?: FilterEqualTypeInput | null;
    garden_table_type?: FilterEqualTypeInput | null;
    garden_tidy?: FilterEqualTypeInput | null;
    gardening_bulbs_type?: FilterEqualTypeInput | null;
    gardening_gift_type?: FilterEqualTypeInput | null;
    gazebo_size?: FilterEqualTypeInput | null;
    gift_wrap_product_type?: FilterEqualTypeInput | null;
    glassware_type?: FilterEqualTypeInput | null;
    gloss_type?: FilterEqualTypeInput | null;
    glove_size?: FilterEqualTypeInput | null;
    gloves_wellies?: FilterEqualTypeInput | null;
    greenhouses_type?: FilterEqualTypeInput | null;
    gutter_down_pipes_type?: FilterEqualTypeInput | null;
    hand_tool_type?: FilterEqualTypeInput | null;
    handtool_type?: FilterEqualTypeInput | null;
    harness_size?: FilterEqualTypeInput | null;
    heater_type?: FilterEqualTypeInput | null;
    hooks_board_material?: FilterEqualTypeInput | null;
    hose_length?: FilterEqualTypeInput | null;
    hosting?: FilterEqualTypeInput | null;
    insulation_type?: FilterEqualTypeInput | null;
    interior_paint_finish?: FilterEqualTypeInput | null;
    ironmongery_type?: FilterEqualTypeInput | null;
    item_type?: FilterEqualTypeInput | null;
    kitchen_product_type?: FilterEqualTypeInput | null;
    kitchen_storage_type?: FilterEqualTypeInput | null;
    kitchen_textiles_type?: FilterEqualTypeInput | null;
    kitchen_utensils?: FilterEqualTypeInput | null;
    ladders_type?: FilterEqualTypeInput | null;
    lawnmower_size?: FilterEqualTypeInput | null;
    lawnmower_type?: FilterEqualTypeInput | null;
    lawnmower_voltage?: FilterEqualTypeInput | null;
    lawnmower_wattage?: FilterEqualTypeInput | null;
    lead_size?: FilterEqualTypeInput | null;
    leads_collars?: FilterEqualTypeInput | null;
    legg_legnthh?: FilterEqualTypeInput | null;
    light_colour?: FilterEqualTypeInput | null;
    light_fitting_type?: FilterEqualTypeInput | null;
    lightbulb_dimmable?: FilterEqualTypeInput | null;
    lighting?: FilterEqualTypeInput | null;
    living_room_furniture?: FilterEqualTypeInput | null;
    lock_material?: FilterEqualTypeInput | null;
    lock_type?: FilterEqualTypeInput | null;
    locking_mechanism?: FilterEqualTypeInput | null;
    material_type?: FilterEqualTypeInput | null;
    metal_curtain_poles?: FilterEqualTypeInput | null;
    mirror_feature?: FilterEqualTypeInput | null;
    mirror_shape?: FilterEqualTypeInput | null;
    mirror_size?: FilterEqualTypeInput | null;
    mirror_type?: FilterEqualTypeInput | null;
    mobile_phone_accessories_type?: FilterEqualTypeInput | null;
    mouse_and_rat_control?: FilterEqualTypeInput | null;
    moving_organisation?: FilterEqualTypeInput | null;
    name?: FilterMatchTypeInput | null;
    netting_matting_mesh?: FilterEqualTypeInput | null;
    no_of_bulbs?: FilterEqualTypeInput | null;
    no_of_shelves?: FilterEqualTypeInput | null;
    no_of_sockets?: FilterEqualTypeInput | null;
    number_of_burners?: FilterEqualTypeInput | null;
    number_of_seats?: FilterEqualTypeInput | null;
    office_furniture_type?: FilterEqualTypeInput | null;
    oil_filled?: FilterEqualTypeInput | null;
    ornament_type?: FilterEqualTypeInput | null;
    outdoor_heater_type?: FilterEqualTypeInput | null;
    pack_quantity?: FilterEqualTypeInput | null;
    paint_brand?: FilterEqualTypeInput | null;
    paint_brush_size?: FilterEqualTypeInput | null;
    paint_colour?: FilterEqualTypeInput | null;
    paint_suitability?: FilterEqualTypeInput | null;
    paint_tin_size?: FilterEqualTypeInput | null;
    paint_type?: FilterEqualTypeInput | null;
    parasol_base_weight?: FilterEqualTypeInput | null;
    parasol_size?: FilterEqualTypeInput | null;
    patio_heater_power_type?: FilterEqualTypeInput | null;
    patio_heater_type?: FilterEqualTypeInput | null;
    paving_type?: FilterEqualTypeInput | null;
    pest_control_type?: FilterEqualTypeInput | null;
    pet_accessories?: FilterEqualTypeInput | null;
    pet_bed_size?: FilterEqualTypeInput | null;
    pet_bed_type?: FilterEqualTypeInput | null;
    pet_food_treats?: FilterEqualTypeInput | null;
    pet_food_type?: FilterEqualTypeInput | null;
    pet_gift_type?: FilterEqualTypeInput | null;
    plant_food_lawncare_type?: FilterEqualTypeInput | null;
    plant_type?: FilterEqualTypeInput | null;
    plastic_box_type?: FilterEqualTypeInput | null;
    plastics_sheds_storage_type?: FilterEqualTypeInput | null;
    plier_type?: FilterEqualTypeInput | null;
    plugs_adaptors_timers_type?: FilterEqualTypeInput | null;
    plumbing_fittings_type?: FilterEqualTypeInput | null;
    pot_planter_colour?: FilterEqualTypeInput | null;
    pots_and_planters_type?: FilterEqualTypeInput | null;
    powder_fillers_type?: FilterEqualTypeInput | null;
    power_rating?: FilterEqualTypeInput | null;
    power_source?: FilterEqualTypeInput | null;
    power_tool_type?: FilterEqualTypeInput | null;
    power_type?: FilterEqualTypeInput | null;
    powertool_accessory_type?: FilterEqualTypeInput | null;
    powertool_type?: FilterEqualTypeInput | null;
    pressure_washers_acc_type?: FilterEqualTypeInput | null;
    price?: FilterRangeTypeInput | null;
    price_gifts?: FilterEqualTypeInput | null;
    product?: FilterEqualTypeInput | null;
    product_form?: FilterEqualTypeInput | null;
    product_typeee?: FilterEqualTypeInput | null;
    productt?: FilterEqualTypeInput | null;
    productt_hammers?: FilterEqualTypeInput | null;
    propulsion_type?: FilterEqualTypeInput | null;
    pyrex_type?: FilterEqualTypeInput | null;
    radiators_type?: FilterEqualTypeInput | null;
    rainwear_sizee?: FilterEqualTypeInput | null;
    rake_material?: FilterEqualTypeInput | null;
    rake_type?: FilterEqualTypeInput | null;
    real_artificial_floristry?: FilterEqualTypeInput | null;
    roofing_sheet_type?: FilterEqualTypeInput | null;
    roofing_type?: FilterEqualTypeInput | null;
    rugs_and_doormats?: FilterEqualTypeInput | null;
    safe_locking_mechanism?: FilterEqualTypeInput | null;
    safe_material?: FilterEqualTypeInput | null;
    safe_resistance?: FilterEqualTypeInput | null;
    safe_type?: FilterEqualTypeInput | null;
    safety_equipment_type?: FilterEqualTypeInput | null;
    sample?: FilterEqualTypeInput | null;
    sanding_type?: FilterEqualTypeInput | null;
    satinwood_type?: FilterEqualTypeInput | null;
    saw_type?: FilterEqualTypeInput | null;
    saw_tyype?: FilterEqualTypeInput | null;
    scale_type?: FilterEqualTypeInput | null;
    screwdriver_type?: FilterEqualTypeInput | null;
    sealant_type?: FilterEqualTypeInput | null;
    seat_hinge_material?: FilterEqualTypeInput | null;
    shackle_type?: FilterEqualTypeInput | null;
    shed_roof_design?: FilterEqualTypeInput | null;
    shelf_finish?: FilterEqualTypeInput | null;
    shelf_material?: FilterEqualTypeInput | null;
    shelf_type?: FilterEqualTypeInput | null;
    short_description?: FilterMatchTypeInput | null;
    shower_accessories_type?: FilterEqualTypeInput | null;
    shower_accessory_type?: FilterEqualTypeInput | null;
    shower_head_type?: FilterEqualTypeInput | null;
    shower_power?: FilterEqualTypeInput | null;
    shower_temperature_control?: FilterEqualTypeInput | null;
    shower_type?: FilterEqualTypeInput | null;
    showers_and_accessories_type?: FilterEqualTypeInput | null;
    shredders_blow_vacs_type?: FilterEqualTypeInput | null;
    sinks_taps_mixers_tpye?: FilterEqualTypeInput | null;
    sku?: FilterEqualTypeInput | null;
    small_appliance_type?: FilterEqualTypeInput | null;
    smoke_alarm_type?: FilterEqualTypeInput | null;
    socket_type?: FilterEqualTypeInput | null;
    solar_product_type?: FilterEqualTypeInput | null;
    spare_part_type?: FilterEqualTypeInput | null;
    storage?: FilterEqualTypeInput | null;
    storage_type?: FilterEqualTypeInput | null;
    storage_typee?: FilterEqualTypeInput | null;
    strippers_and_cleaners_type?: FilterEqualTypeInput | null;
    switch_type?: FilterEqualTypeInput | null;
    switches_and_sockets_profile?: FilterEqualTypeInput | null;
    switches_and_sockets_type?: FilterEqualTypeInput | null;
    swithces_and_sockets_finish?: FilterEqualTypeInput | null;
    tableware_themes?: FilterEqualTypeInput | null;
    tableware_type?: FilterEqualTypeInput | null;
    tape_type?: FilterEqualTypeInput | null;
    tea_coffee_and_water_type?: FilterEqualTypeInput | null;
    telephone_connection_type?: FilterEqualTypeInput | null;
    telephone_product_type?: FilterEqualTypeInput | null;
    test_colour?: FilterEqualTypeInput | null;
    test_fabric?: FilterEqualTypeInput | null;
    test_material?: FilterEqualTypeInput | null;
    test_size?: FilterEqualTypeInput | null;
    textile_type?: FilterEqualTypeInput | null;
    thickness?: FilterEqualTypeInput | null;
    tile_adhesive_grout_type?: FilterEqualTypeInput | null;
    tile_finish?: FilterEqualTypeInput | null;
    tile_shape?: FilterEqualTypeInput | null;
    tile_size?: FilterEqualTypeInput | null;
    tile_type?: FilterEqualTypeInput | null;
    tiling_tools_accessories_type?: FilterEqualTypeInput | null;
    timber_depth?: FilterEqualTypeInput | null;
    timber_length?: FilterEqualTypeInput | null;
    timber_type?: FilterEqualTypeInput | null;
    timber_width?: FilterEqualTypeInput | null;
    toilet_accessories?: FilterEqualTypeInput | null;
    toilet_seat_material?: FilterEqualTypeInput | null;
    toilet_seat_type?: FilterEqualTypeInput | null;
    toolboxes_and_storage_material?: FilterEqualTypeInput | null;
    toolboxes_and_storage_type?: FilterEqualTypeInput | null;
    torch_type?: FilterEqualTypeInput | null;
    trailing_sockets_cable_reels?: FilterEqualTypeInput | null;
    tv_accessories?: FilterEqualTypeInput | null;
    type_of_lightd?: FilterEqualTypeInput | null;
    url_key?: FilterEqualTypeInput | null;
    usability_type?: FilterEqualTypeInput | null;
    utensils_and_accessories_type?: FilterEqualTypeInput | null;
    v20?: FilterEqualTypeInput | null;
    vacuum_product_type?: FilterEqualTypeInput | null;
    varnish_finish?: FilterEqualTypeInput | null;
    ventilation_type?: FilterEqualTypeInput | null;
    voltage?: FilterEqualTypeInput | null;
    wall_art_type?: FilterEqualTypeInput | null;
    wall_shelves_type?: FilterEqualTypeInput | null;
    wall_tile_type?: FilterEqualTypeInput | null;
    wallpaper_accessories_yype?: FilterEqualTypeInput | null;
    wallpaper_type?: FilterEqualTypeInput | null;
    wardrobe_fitting_finish?: FilterEqualTypeInput | null;
    wardrobe_fitting_type?: FilterEqualTypeInput | null;
    waste_pipes_fittings_traps_typ?: FilterEqualTypeInput | null;
    waste_type?: FilterEqualTypeInput | null;
    wastes_plugs_chains_type?: FilterEqualTypeInput | null;
    watering_can_size?: FilterEqualTypeInput | null;
    watering_type?: FilterEqualTypeInput | null;
    wattage?: FilterEqualTypeInput | null;
    white_spirits_turpentine_type?: FilterEqualTypeInput | null;
    wild_bird_care_type?: FilterEqualTypeInput | null;
    window_cleaning_type?: FilterEqualTypeInput | null;
    wood_finish?: FilterEqualTypeInput | null;
    worktop_accessories?: FilterEqualTypeInput | null;
    workwear_accessories?: FilterEqualTypeInput | null;
    workwear_size?: FilterEqualTypeInput | null;
    workwear_type?: FilterEqualTypeInput | null;
}

//==============================================================
// END Enums and Input Objects
//==============================================================
export {};
